module.exports = __webpack_public_path__ + "media/xupian.d0fe8d1b.mp4";